module.exports = __webpack_public_path__ + "static/media/1009833.86a33d95.jpg";